import {
  SLACK_ACCOUNTS,
  SLACK_OAUTH_URL,
  SLACK_REVOKE,
  SLACK_CHANNELS,
  SLACK_SEND_TEST,
} from '@mm/api-routes';
import { SlackDataType } from '../model/CampaignsModel';
import AuthenticatedController from './AuthenticatedController';

export default class SlackController extends AuthenticatedController {
  static async getOauthUrl(redirectTo: string, facebookPageId: number) {
    return super.get(SLACK_OAUTH_URL, {
      redirect_to: redirectTo,
      facebookPageId,
    });
  }

  static async getAccounts(facebookPageId: number) {
    return super.get(SLACK_ACCOUNTS, {
      facebook_page_id: facebookPageId,
    });
  }

  static async getChannels(
    teamId: string,
    facebookPageId: number,
    force: boolean = false,
  ) {
    return super.get(SLACK_CHANNELS, {
      team_id: teamId,
      facebook_page_id: facebookPageId,
      force,
    });
  }

  static async revokeAccess(accountId: number, facebookPageId: number) {
    return super.post(SLACK_REVOKE, {
      account_id: accountId,
      facebookPageId,
    });
  }

  static async sendTest(facebookPageId: number, params: SlackDataType) {
    return super.post(SLACK_SEND_TEST, { facebookPageId, ...params });
  }

  static async sendConnectionTest(
    connectionId: number,
    facebookPageId: number,
    accountId: number,
  ) {
    return super.post(SLACK_SEND_TEST, {
      connectionId,
      facebookPageId,
      accountId,
    });
  }
}
